module.exports = __webpack_public_path__ + "img/2.de94c0cc.jpg";